import { render, staticRenderFns } from "./TableOfBidders.vue?vue&type=template&id=3d8f4a28&scoped=true"
import script from "./TableOfBidders.vue?vue&type=script&lang=js"
export * from "./TableOfBidders.vue?vue&type=script&lang=js"
import style0 from "./TableOfBidders.vue?vue&type=style&index=0&id=3d8f4a28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8f4a28",
  null
  
)

export default component.exports